import React, { useMemo } from "react";
import ProductDetailCard from "./ProductDetailCard";

function CoverageDetailsProductDetail({ activeProduct, products, showClaims }) {
  const productNames = Object.keys(products);

  const product = useMemo(() => {
    return products[activeProduct];
  }, [activeProduct]);

  return (
    <>
      {productNames.map((key) => (
        <div role="tabpanel" hidden={activeProduct !== key}>
          {activeProduct === key && <ProductDetailCard product={product} productKey={key} showClaims={showClaims} />}
        </div>
      ))}
    </>
  );
}

export default CoverageDetailsProductDetail;
